import { cn } from "@/lib/utils";

// "estadisticas" NO es un estado de incidente: es una vista. Vive aquí porque
// Edgar la quiere con el mismo aspecto que los demás apartados, pero la página
// la traduce antes de consultar el API — el tipo de `IncidentFilters` no la
// conoce y no debe conocerla.
export type StatusFilterValue =
  | "open"
  | "resolved"
  | "all"
  | "needs_human"
  | "estadisticas";

interface Props {
  value: StatusFilterValue;
  onChange: (next: StatusFilterValue) => void;
}

const OPTIONS: Array<{ value: StatusFilterValue; label: string }> = [
  { value: "open", label: "Abiertos" },
  { value: "needs_human", label: "Requiere intervención" },
  { value: "resolved", label: "Resueltos" },
  { value: "all", label: "Todos" },
  { value: "estadisticas", label: "Estadísticas" },
];

export function StatusFilter({ value, onChange }: Props) {
  return (
    <div className="inline-flex h-9 rounded-md border bg-background p-1 text-sm">
      {OPTIONS.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            aria-pressed={active}
            className={cn(
              "rounded px-3 transition-colors",
              active
                ? "bg-primary text-primary-foreground shadow-sm"
                : "text-muted-foreground hover:bg-accent",
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
